/**
 * Checks if a specific path matches a template path containing placeholders.
 *
 * @param {string} specificPath - The specific path to match (e.g., 'actions[id:70q6lorxah1e].name').
 * @param {string} templatePath - The template path with placeholders (e.g., 'actions[id:{{actionId}}].name').
 * @returns {boolean} True if the paths match, false otherwise.
 *
 * @example
 * matchPathWithTemplate('actions[id:70q6lorxah1e].name', 'actions[id:{{actionId}}].name')
 * // Returns true
 */
export const matchPathWithTemplate = (specificPath, templatePath) => {
  if (typeof specificPath !== 'string' || typeof templatePath !== 'string') {
    return false;
  }

  // Split the paths into segments
  const specificSegments = specificPath.split('.');
  const templateSegments = templatePath.split('.');

  // Check if the number of segments match
  if (specificSegments.length !== templateSegments.length) {
    return false;
  }

  // Compare each segment
  for (let i = 0; i < specificSegments.length; i++) {
    const specificSegment = specificSegments[i];
    const templateSegment = templateSegments[i];

    // If the template segment contains a placeholder
    if (templateSegment.includes('{{') && templateSegment.includes('}}')) {
      // Extract the parts before and after the placeholder
      const parts = templateSegment.split(/\{\{([^}]+)\}\}/);

      // Check if the specific segment starts with the part before the placeholder
      // and ends with the part after the placeholder
      if (parts.length >= 3) {
        const beforePlaceholder = parts[0];
        const afterPlaceholder = parts[2];

        if (!specificSegment.startsWith(beforePlaceholder) || !specificSegment.endsWith(afterPlaceholder)) {
          return false;
        }
      } else {
        // If there's only one placeholder in the segment
        const placeholder = templateSegment.match(/\{\{([^}]+)\}\}/)[0];
        const beforePlaceholder = templateSegment.split(placeholder)[0];
        const afterPlaceholder = templateSegment.split(placeholder)[1];

        if (!specificSegment.startsWith(beforePlaceholder) || !specificSegment.endsWith(afterPlaceholder)) {
          return false;
        }
      }
    } else if (specificSegment !== templateSegment) {
      // If no placeholder, segments must match exactly
      return false;
    }
  }

  return true;
};
